module.exports = __webpack_public_path__ + "img/brentford-logo-icon.446b10b0.png";